/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator>): InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator(), model);
        InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator>): InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorLambdaArchitectureQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the Lambda instruction set architecture
     */
    starts_with: string;

}
